export function isJsonRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function parseStrictJsonValue(raw: string): unknown | null {
  try {
    return JSON.parse(raw.trim()) as unknown;
  } catch {
    return null;
  }
}

export function parseStrictJsonRecord(raw: string): Record<string, unknown> | null {
  const parsed = parseStrictJsonValue(raw);
  return isJsonRecord(parsed) ? parsed : null;
}

export function parseStrictJsonRecordArray(raw: string): Record<string, unknown>[] | null {
  const parsed = parseStrictJsonValue(raw);
  if (isJsonRecord(parsed)) return [parsed];
  if (!Array.isArray(parsed)) return null;
  const records = parsed.filter(isJsonRecord);
  return records.length === parsed.length ? records : null;
}
